<template>
    <b-modal modal-class="prescription-modal" :hide-footer="loading" :title="t('Prescription')" v-model="opened">
        <div class="text-center" v-if="loading === true">
            <loading size="sm"/>
            {{t('Saving')}}
        </div>
        <titan-form ref="titanForm"
                    :render-in-card="false"
                    :schema="formSchema"
                    v-on:saveData="create()"
                    :model="formModel"
                    v-if="loading === false"
        />
        <template slot="modal-footer">
            <button type="button"
                    class="btn btn-success mr-auto"
                    v-on:click="$refs.titanForm.saveData()"
            >
                <font-awesome-icon icon="plus"/>
                {{t('Add prescription')}}
            </button>
        </template>
    </b-modal>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../../../core/Components/loading';

    export default {
        components: {
            Loading,
            TitanForm
        },
        props: {
            id: {
                type: Number,
                required: true,
            },
            prescribed: {
                type: Number,
                required: true,
            },
            approved: {
                type: Number|null,
                required: true,
            }
        },
        computed: {
            toPrescribe() {
                return this.approved - this.prescribed;
            }
        },
        created() {
            this.resetLimits();
        },
        methods: {
            open() {
                this.opened = true;
                this.resetLimits();
            },
            create() {
                this.loading = true;
                let data = {...this.formModel};
                data.id = this.id;
                this.$store.dispatch('applicationPrescriptions/create', data).then(data => {
                    this.$emit('added', {number: this.formModel.number});
                    this.resetLimits();
                    this.opened = false;
                    this.loading = false;
                    this.$store.dispatch('alert/success', 'Drug was successfully prescribed');
                }).catch(() => {
                    this.loading = false;
                });
            },
            resetLimits() {
                this.formSchema[0].fields[0].max = this.toPrescribe;
                this.formSchema[0].fields[0].textAppend = this.t('Max:') + ' ' + this.toPrescribe;
            }
        },
        data() {
            return {
                loading: false,
                opened: false,
                formModel: {
                    number: null,
                    createdOn: new Date(),
                    prescribedTo: (new Date()).setMonth((new Date()).getMonth() + 1),
                },
                formSchema: [
                    {
                        type: 'main',
                        showHeading: false,
                        fields: [
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Amount'),
                                model: 'number',
                                required: true,
                                max: 5,
                                validator: VueFormGenerator.validators.number,
                                textAppend: '',
                            }, {
                                type: 'titanDatePicker',
                                label: this.t('Prescribed on'),
                                model: 'createdOn',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                            }, {
                                type: 'titanDatePicker',
                                label: this.t('Prescribed to'),
                                model: 'prescribedTo',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                            }
                        ]
                    },
                ],
            }
                ;
        }
    }
</script>
<style lang="scss">
    .prescription-modal {
        .titan-form-block {
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/prescription.vue